import type { ComponentProps } from 'react'

import { TextField } from '@/components/ui/text-field.tsx'
import type { ManagedField } from '@/modules/message/components/editor/fields/managed-field'
import { classNames } from '@/utils/helpers'

export type MessageTitleSelectorProps = ComponentProps<'div'> & {
  field: ManagedField<string>
}

export const MessageTitleSelector = (props: MessageTitleSelectorProps) => {
  const { className, field, ...rest } = props

  return (
    <div
      {...rest}
      className={classNames('flex flex-col gap-1.5', className)}
    >
      <label className="text-sm font-medium text-text-default">Title</label>
      <div className="relative flex flex-grow items-center">
        <TextField
          {...field}
          withEmojiPicker
          placeholder="Enter Title"
          testId="message-title-input"
        />
      </div>
      {field.error && (
        <span className="text-xs font-medium text-danger-default">
          {field.error.message}
        </span>
      )}
    </div>
  )
}
